import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import modules from './modules';

// ローカルストレージに保管して問題ない情報のみpathsに含めること
export default createStore({
  modules,
  plugins: [
    createPersistedState({
      key: 'vuex',
      paths: [],
      storage: window.localStorage,
    }),
  ],
});
